import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const putNote = (
    backend: string,
    token: string,
    id: number,
    Title: string,
    Text: string,
    EmployeeID: string,
    Date: string,
    ProjectID: string,
    CreatedByID: number
) => {
    return fetch(
        `${getApiUrl(backend)}notes/${id}`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Title,
                Text,
                EmployeeID,
                Date,
                ProjectID,
                CreatedByID,
                ChangedByID: CreatedByID
            })
        }
    );
};

export default putNote;
